<template>
    <div id="app">
        <h1>{{name}}</h1>
    </div>
</template>

<script>
export default {
    name: 'Venues',
    data() {
        return {
            name: "Venues"
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Venues.vue